import styled from "styled-components";

const PageTitle = styled.h1`
  width: 100%;
  font-size: 1.3em;
  line-height: 120%;
  text-align: center;
  font-weight: 700;
  margin: 0;
  @media (max-width: 768px) {
    text-align: center;
  }

  @media (max-width: 576px) {
    font-size: 1.2em;
  }
`;

export default PageTitle;
